import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';

export type LiveSourceKey =
  | 'ndaapprovals'
  | 'andaapprovals'
  | 'newdosageform'
  | 'tentativeandaapproval'
  | 'labelling'
  | 'newapprovedstrength'
  | 'updatedbeguidance'
  | 'newlistedpatentsdatabase'
  | 'delistedpatentsdatabase'
  | 'newApprovedIndication';

@Injectable({
  providedIn: 'root'
})
export class ImportantUpdatesService {

  private readonly routeMap: Record<LiveSourceKey, string> = {
    ndaapprovals: AppConstants.API.LIVE_UPDATES.NDA_APPROVALS,
    andaapprovals: AppConstants.API.LIVE_UPDATES.ANDA_APPROVALS,
    newdosageform: AppConstants.API.LIVE_UPDATES.NEW_DOSAGE_FORM,
    tentativeandaapproval: AppConstants.API.LIVE_UPDATES.TENTATIVE_ANDA_APPROVAL,
    labelling: AppConstants.API.LIVE_UPDATES.LABELLING,
    newapprovedstrength: AppConstants.API.LIVE_UPDATES.NEW_APPROVED_STRENGTH,
    updatedbeguidance: AppConstants.API.LIVE_UPDATES.UPDATE_BE_GUIDANCE,
    newlistedpatentsdatabase: AppConstants.API.LIVE_UPDATES.LISTED_PATENTS_DATABASE,
    delistedpatentsdatabase: AppConstants.API.LIVE_UPDATES.DELISTED_PATENTS_DATABASE,
    newApprovedIndication: AppConstants.API.LIVE_UPDATES.NEW_APPROVED_INDICATION,
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private errorHandlerService: ErrorHandlerService
  ) { }


  fetch(source: LiveSourceKey): Observable<any[]> {
    const url = `${AppConstants.API_ENDPOINT}${this.routeMap[source]}?user_email=${localStorage.getItem('email') || ''}`;
    return this.http.get<any>(url).pipe(
      map(res => Array.isArray(res) ? res : (res?.data ?? [])),
      catchError((error) => this.errorHandlerService.handleError(error))
    );
  }

  updateIsInLive(uniq_number: string | string[], is_in_live: boolean, all_live: boolean, field: string): Observable<any> {
    const url = `${AppConstants.API_ENDPOINT}${AppConstants.API.LIVE_UPDATES.UPDATE_IS_IN_LIVE}`;
    return this.http.post(url, {
      uniq_number,
      is_in_live,
      all_live,
      field
    }).pipe(
      catchError((error) => this.errorHandlerService.handleError(error))
    );
  }
}
